import axios from 'axios';
import { toast } from 'sonner';

/**
 * Descarga un archivo generado por el backend (PDF, Excel) usando el token de axios.
 * Muestra un toast si falla.
 */
export async function downloadFile(url, { params, fallbackName = 'archivo' } = {}) {
  try {
    const res = await axios.get(url, { params, responseType: 'blob' });
    const disposition = res.headers['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/.exec(disposition);
    const filename = match ? match[1] : fallbackName;

    const blobUrl = window.URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
    return true;
  } catch (err) {
    let detail = 'No se pudo descargar el archivo';
    try {
      // Con responseType 'blob' el error también llega como blob
      const text = await err.response?.data?.text?.();
      if (text) detail = JSON.parse(text).detail || detail;
    } catch (_) { /* ignorar */ }
    toast.error(typeof detail === 'string' ? detail : 'No se pudo descargar el archivo');
    return false;
  }
}
